// XXX CSS is used on Web, JavaScript styles are use only for mobile. Export an
// (empty) object so that styles[*] statements on Web don't trigger errors.
export default {};

export const DROPBOX_LOGO = 'images/dropboxLogo_square.png';
export const ONEDRIVE_LOGO = 'images/onedrivelogo.png';

export const ICON_SHARE = 'images/icon-users.png';

export const MH_LOGO = 'images/MHLogo_square.png';

export const AWS_LOGO = 'images/aws_logo.png';

export const LOADING_INDICATOR = 'images/loading2.gif';
